<template>
<div class="sync-detail" v-if="flag==index&&detailShow" v-cloak>
    <div class="sync-title">
        {{$t('language.common.syncDetails')}}
    </div>
     <div class="detail-sync-count" v-if="itemSyncDetail.syncDetail&&itemSyncDetail.syncDetail.runningStatus==1">
         <div class="sync-line" >{{$t('language.common.countFiles')}}:({{itemSyncDetail.syncDetail.readyFindFileCount}}{{$t('language.common.transferFiles')}},{{itemSyncDetail.syncDetail.totalBytes|formatByte}})</div>
    </div>
    <div class="sync-detail-one">
        <div class="sync-line">
            <div style="float:left;">{{$t('language.common.sync')}}:</div>
            <div class="catelog-color catelog-style catelog-width" @click.stop="toSourceCatalog(itemSyncDetail.syncDetail)" :title="itemSyncDetail.fromItem.nodes|getCatalog|getCatalogTitle">{{itemSyncDetail.fromItem.nodes|getCatalog}}</div>
        </div>
        <div class="sync-line">
            <div style="float:left;">{{$t('language.common.with')}}:</div>
            <div class="catelog-color catelog-style catelog-width" @click.stop="toAimCatalog(itemSyncDetail)"  :title="itemSyncDetail.toItem.nodes|getCatalog|getCatalogTitle">{{itemSyncDetail.toItem.nodes|getCatalog}}</div>
        </div>
    </div>
    <div class="sync-detail-two">
        <div class="sync-all-line">
            <span class="sync-column-left">{{$t('language.common.fileProcess')}}:
                <span v-if="itemSyncDetail.syncDetail&&itemSyncDetail.syncDetail.runningStatus!=0&&itemSyncDetail.syncDetail">
                {{itemSyncDetail.syncDetail.addFileCount}}/{{itemSyncDetail.syncDetail.readyFindFileCount}}</span>
            </span>
        </div>
        <div class="sync-line">
            <span class="sync-column-left">{{$t('language.common.dataProcess')}}:
                <span v-if="itemSyncDetail.syncDetail&&itemSyncDetail.syncDetail.runningStatus!=0&&itemSyncDetail.syncDetail">
                {{itemSyncDetail.syncDetail.readedBytes|formatByte}}/{{itemSyncDetail.syncDetail.totalBytes|formatByte}}</span>
                </span>
            <span class="sync-column-right">{{$t('language.popup.progress')}}:
                <span v-if="itemSyncDetail.syncDetail&&itemSyncDetail.syncDetail.runningStatus>1">
               <span v-if="itemSyncDetail.syncDetail.percent"> {{itemSyncDetail.syncDetail.percent+'%'}}</span>
                <span v-if="!itemSyncDetail.syncDetail.percent">0%</span>
                </span>
            </span>
        </div>
        <div class="sync-line">
            <span class="sync-column-left">{{$t('language.common.startTime')}}:<span v-if="itemSyncDetail.syncDetail&&itemSyncDetail.syncDetail.runningStatus!=0">{{itemSyncDetail.syncDetail.taskStartTimeLong|transferTime}} </span></span>
            <span class="sync-column-right" >{{$t('language.common.currentRate')}}: <span v-if="itemSyncDetail.syncDetail&&itemSyncDetail.syncDetail.runningStatus>1">{{itemSyncDetail.syncDetail.speed}}</span></span>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: ['flag', 'index', 'detailShow', 'itemSyncDetail', 'threadChange'],
    data: function () {
        return {}
    },
    watch: {
        threadChange(newValue, oldValue) {
            this.$forceUpdate();
        },
           '$store.state.threadChange': function (newValue, oldValue) {
            this.$forceUpdate();
            this.$parent.$forceUpdate();
            if(this.$parent.showTaskStatus){
            this.$parent.showTaskStatus();
            }
        }
    },
    methods: {
        toSourceCatalog(item) {//跳转到源云盘
            let fromItem = {
                driveId: item.sourceToken,
                nodes: item.sourceNode,
                driveType: item.sourceCloudType,
                name: item.sourceFilename,
                id: item.sourceId
            };
            if(this.$parent.$parent.toSourceCatalog == undefined){//如果是单个的同步任务跳转到源目录
            this.$parent.toSourceCatalog(fromItem);
            }else{
            this.$parent.$parent.toSourceCatalog(fromItem);//如果是多个目标的同步任务的源目录
            }
        },
        toAimCatalog(item) {//跳转到目标目录
            let name;
            if(item.toItem){
           name=item.toItem.name;
           }else{
           name=item.toItem.nodes[0].fileName;
           }
             let toItem = {
            driveId: item.toItem.driveId,
            nodes: item.toItem.nodes,
            driveType: item.toItem.driveType,
            name: name,
            id: item.toItem.id
            };
            if(this.$parent.$parent.toAimCatalog == undefined){//如果是单个的同步任务跳转到目标目录
               this.$parent.toAimCatalog(toItem);
            }else{
            this.$parent.$parent.toAimCatalog(toItem);//如果是多个的同步任务跳转到目标目录
            }
        },
    }
}
</script>

<style scoped>
.sync-detail {
    width: 100%;
    height: 190px;
    /*no*/
    font-size: 12px;
    /*no*/
    line-height: 20px;
    /*no*/
    color: #6f7886;
    box-sizing: border-box;
    padding: 10px 20px 16px 20px;
    /*no*/
}

.sync-title {
    font-size: 16px;
    /*no*/
    font-weight: bold;
    color: #000;
}

.sync-detail-one {
    width: 100%;
    height: 53px;
    /*no*/
    margin: 15px 0px 16px 0px;
    /*no*/
}

.sync-detail-two {
    width: 100%;
    height: 70px;
    /*no*/
    margin: 10px 0px 16px 0px;
    /*no*/
}

.sync-line {
    width: 100%;
    float: left;
}

.sync-column-left {
    width: 38%;
    float: left;
}

.sync-column-right {
    width: 54%;
    float: left;
}

.sync-all-line {
    width: 100%;
    height: 20px;
    /*no*/
}


</style>



// WEBPACK FOOTER //
// src/components/common/tabs/tabs_task_list/tabs_sync_detail.vue